import SyndigoContent from './SyndigoContent'

export default SyndigoContent
